import * as React from 'react';
import { useState } from 'react';
import { useBOMProjectStore } from 'src/hooks/bom_project';

const EditProject = (props) => {

    const { addProjectToEditStack, projectData } = props

    const [{ }, { fetch_bom_project_detail_with_bom }, { edit_project }] = useBOMProjectStore();
    const [projectName, SetProjectName] = useState(projectData && projectData.projectName);
    const [projectNameError, SetProjectNameError] = useState('');
    const [projectNameErrorStatus, SetProjectNameErrorStatus] = useState(false);

    const onProjectNameChange = async (value) => {
        SetProjectName(value);
        if (projectNameErrorStatus === true) {
            if (value.trim().length === 0) {
                SetProjectNameError('The input Project Name is Invalid')
            } else if (projectName.trim().length > 100) {
                SetProjectNameError('The maximum characters supported is 100')
            } else {
                SetProjectNameErrorStatus(false)
            }
        }
    }

    const onSaveProject = async () => {
        let error = false
        if (projectName.trim().length === 0) {
            error = true;
            SetProjectNameErrorStatus(error)
            SetProjectNameError('The input Project Name is Invalid')
        } else if (projectName.trim().length > 100) {
            error = true;
            SetProjectNameErrorStatus(error)
            SetProjectNameError('The maximum characters supported is 100')
        } else {
            error = false
            SetProjectNameErrorStatus(error)
        }

        if (!error) {
            let params = {}
            params.projectName = projectName;
            params.projectId = projectData.projectId;
            let editRes = await edit_project(params)
            if (editRes !== undefined && editRes.payload.data !== undefined) {
                await addProjectToEditStack(projectData)
                await fetch_bom_project_detail_with_bom();
            }
        }
    }

    return (
        <>
            <div className="edit-project-box ps-3">
                <input type="text" className={projectNameErrorStatus === true && projectNameError  ? "form-control form-control-sm mb-2 w295 error" : "form-control form-control-sm mb-2 w295"}
                       id="project"
                       placeholder="Enter project" name="project"
                       value={projectName}
                       onChange={(e) => {
                           onProjectNameChange(e.target.value)
                       }}
                />
                <p className="error">{projectNameErrorStatus === true && projectNameError}</p>
                <p className="w-100 m-b-10 mt-2"><a className="text-blue2" href={void (0)}
                    onClick={async () => {
                        await addProjectToEditStack(projectData)
                    }}
                >Cancel </a> / <a
                    className="text-blue2" data-toggle="modal" href={void (0)}
                    onClick={() => onSaveProject()}>Save</a></p>
            </div>
        </>
    );
}

export default EditProject;